import {HasRole, useIsAuthenticated} from "@mytour/platform";
import {Navigate} from "react-router";

export function HomePageRedirect() {
  const {isAuthenticated, isAuthenticatedLoading} = useIsAuthenticated();

  // Wait for auth check
  if (isAuthenticatedLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Workers are redirected to events, managers to home
  return (
    <>
      <HasRole role="worker">
        <Navigate to="/planning" replace />
      </HasRole>
      <HasRole role="manager">
        <Navigate to="/home" replace />
      </HasRole>
    </>
  );
}
